import React from 'react';
import { FaBroadcastTower } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useT } from '../../contexts/LocaleContext.jsx';
import '../../styles/LiveButton.css';

const LiveButton = ({ bandId, isStreaming = false, className = '' }) => {
  const navigate = useNavigate();
  const t = useT();

  // Only render if band is streaming
  if (!isStreaming) {
    return null;
  }

  const handleClick = () => {
    navigate(`/performers/${bandId}/stream`);
  };

  return (
    <button 
      className={`live-button ${className}`}
      onClick={handleClick}
      title={t('live.joinStream')}
      data-testid="live-button"
    >
      <FaBroadcastTower className="live-button-icon" />
      <span className="live-button-text">{t('common.status.live')}</span>
      <div className="live-button-pulse" />
    </button>
  );
};

export default LiveButton;